// import SecureLS from 'secure-ls'
// var loggingIn = new SecureLS({encodingType: 'aes'});
// loggingIn.set('loggingIn', {data: true});

export const initialStateGlobalSettings = () => ({
    /***
     * Constante para estado inicial de la store
     */
    // loggingIn: false,
    logoutState: false,
    idleLogout: false,
    idleTime: 360000,
    daysResume: 0,
    salary: 0,
    ipc: 0,
    health: 0,
    pension: 0,
    compensation: 0,
    arl: 0,
    severancePayInterest: 0,
    ageForAssurance: 0,
    ageForAssurancePercentBelow: 0,
    ageForAssurancePercentAbove: 0,
    resetToken: null,
    resetUserId: null,
    user: {},
    backup: false,
    activityTypeSubcategory: null
})

export default initialStateGlobalSettings()